<template>
  <tk-container class="addrecord" :status="status">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      添加记录
    </tkui-header>
    <div class="body">
      <div class="type">
        <tk-flex middle between>
          <p class="text unshrink">请选择类型</p>
          <tk-flex middle class="fill" style="position: relative">
            <tkui-list style="width: 100%">
              <tkui-list-picker @selected="select" v-model="type" :items="items" label=""></tkui-list-picker>
            </tkui-list>
            <tk-icon @click.native="aa" v-if="!items[type]" style="color: #999999;position: absolute;right: 0">dropdown</tk-icon>
          </tk-flex>
        </tk-flex>
      </div>
      <input v-model="worker" type="text" class="input" placeholder="请填写姓名">
      <textarea v-model="content" placeholder="填写维修详情" class="content" cols="30" rows="10"></textarea>
      <tkui-button @click.native="up" class="raised primary rounded block">提交</tkui-button>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        status: false,
        content: '',
        worker: '',
        type: '',
        items: {
          item0: '',
          item1: '客户报修',
          item2: '滤芯更换',
          item3: '清除水垢',
          item4: '定期维护',
          item5: '告警处理'
        },
        selectType: ''
      }
    },
    computed: {
      machine () {
        return this.$store.state.machine
      }
    },
    methods: {
      back () {
        this.$back()
      },
      select () {
        this.selectType = this.items[this.type]
      },
      async up () {
        if (!this.selectType || this.selectType === '') {
          this.$tkGlobal.toast.add('请选择维修类型')
          return
        }
        if (!this.worker || /^\s+$/g.test(this.worker)) {
          this.$tkGlobal.toast.add('请填写姓名')
          return
        }
        if (!this.content || /^\s+$/g.test(this.content)) {
          this.$tkGlobal.toast.add('请填写内容')
          return
        }
        try {
          this.status = 'waiting'
          await this.$tkParse.post('/classes/repair', {
            'machine': this.machine.objectId,
            'worker': this.worker,
            'content': this.content,
            'type': this.selectType
          })
          this.status = false
          this.type = ''
          this.worker = ''
          this.content = ''
          this.$setFlash('update')
          this.$tkGlobal.toast.add('添加成功')
          this.$back()
        } catch (e) {
          this.status = false
          this.$tkGlobal.toast.add('添加失败')
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .addrecord{
    background: #ffffff;
    .body{
      padding: 15px;
      .type{
        border-bottom: 1px solid #F1F5F8;
        padding-bottom: 10px;
        .text{
          font-size: 16px;
          color: #999999;
          margin-bottom: 0!important;
        }
      }
      .input{
        display: block;
        height: 50px;
        width: 100%;
        margin-top: 10px;
        border-bottom: 1px solid #F1F5F8;
        color: #999999;
        font-size: 16px;
        letter-spacing: 1px;
      }
      .content{
        width: 100%;
        height: 120px;
        box-sizing: border-box;
        border: 1px solid #CCCCCC;
        padding: 5px;
        resize: none;
        font-size: 16px;
        color: #999999;
        margin: 25px 0 25px 0;
      }
    }
  }
  textarea::-webkit-input-placeholder {
    color: #999999;
    font-size: 16px;
    letter-spacing: 1px;
  }
  input::-webkit-input-placeholder {
    color: #999999;
    font-size: 16px;
    letter-spacing: 1px;
  }
  input:-moz-placeholder {
    color: #999999;
    font-size: 16px;
  }
  input::-moz-placeholder {
    color: #999999;
    font-size: 16px;
  }
  input:-ms-input-placeholder {
    color: #999999;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/page/app/maintain/addRecord.vue